import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FooterComponent, NotificationBarComponent } from './components';
import { BannerComponent } from './components/banner/banner.component';
import { EnvironmentSashComponent } from './components/environment-sash/environment-sash.component';
import { HeaderComponent } from './components/header/header.component';
import { AttachToFormDirective, SelectDirective } from './directives';
import { LetDirective } from './directives/let.directive';
import { SharedPipesModule } from './pipes/pipes.module';
import { BetaDisclaimerDialogComponent } from '../dialogs/beta-disclaimer-dialog/beta-disclaimer-dialog.component';
import { ErrorBarComponent } from './components/error-bar/error-bar.component';

const MATERIAL_MODULES = [
  MatButtonModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatToolbarModule,
  MatDialogModule,
];

const SHARED_COMPONENTS = [
  BannerComponent,
  FooterComponent,
  NotificationBarComponent,
  HeaderComponent,
  EnvironmentSashComponent,
  BetaDisclaimerDialogComponent,
  ErrorBarComponent,
];

const SHARED_DIRECTIVES = [
  AttachToFormDirective,
  SelectDirective,
  LetDirective,
];

@NgModule({
  declarations: [SHARED_COMPONENTS, SHARED_DIRECTIVES],
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    OverlayModule,
    SharedPipesModule,
    BrowserAnimationsModule,
    MATERIAL_MODULES,
  ],
  exports: [SHARED_COMPONENTS, SHARED_DIRECTIVES, SharedPipesModule],
})
export class JsgSharedModule {
  constructor(iconRegistry: MatIconRegistry) {
    iconRegistry.setDefaultFontSetClass('material-icons-outlined');
  }
}
